class Popover extends HTMLElement {
  constructor() {
    super();
    this.bindEvents = this.bindEvents.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
  }
  connectedCallback() {
    this.popoverButton = this.querySelector(".js-popover-button");
    this.popoverContent = this.querySelector(".js-popover-content");
    this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    if (this.popoverButton && this.popoverContent && !this.isMobile) {
      this.bindEvents();
    }
  }
  bindEvents() {
    this.popoverButton.addEventListener("click", this.togglePopover);
    document.addEventListener("click", (event) => {
      if (event.target !== this && !this.contains(event.target)) {
        this.classList.remove("visible");
      }
    });
  }
  // Function to toggle the visibility of the popover content
  togglePopover() {
    this.classList.toggle("visible");
  }
}
customElements.define("w3-popover", Popover);
